import React, { useState } from "react"
import { Modal, Form, Label, Input } from "reactstrap"
import { post } from "utils/apiClient"

const CancelModal = props => {
  const stop = props.stop || {}
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [reason, setReason] = useState("")

  const reset = () => {
    setError(null)
    setReason("")
  }

  const close = () => {
    reset()
    props.toggle()
  }

  const submit = async e => {
    e.preventDefault()
    if (!reason || reason.trim() === "") {
      setError("Please enter a reason for cancelling.")
      return
    }
    setError(null)
    setLoading(true)

    const payload = {
      stopId: stop.stopId,
      reasonCode: reason.trim(),
    }

    try {
      await post("crs/cancel", payload)
      setLoading(false)
      if (props.refreshTable) props.refreshTable()
      close()
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.")
      setLoading(false)
    }
  }

  return (
    <Modal isOpen={props.isOpen} toggle={close} centered size="lg">
      <div className="modal-header">
        <h5 className="modal-title mt-0">Cancel appointment</h5>
        <button type="button" onClick={close} className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <Form onSubmit={submit}>
        <div className="modal-body">
          <p>
            Are you sure you want to cancel this confirmed appointment
            {stop.scheduledAppointmentDate ? (
              <>
                {" "}scheduled on{" "}
                <span className="text-primary">
                  {stop.scheduledAppointmentDate} @ {stop.scheduledAppointmentTime}
                </span>
              </>
            ) : null}
            ?
          </p>
          <div className="form-group mb-3">
            <Label>
              Reason<span className="text-danger"> *</span>
            </Label>
            <Input
              type="textarea"
              rows="3"
              placeholder="Enter a reason for cancelling"
              value={reason}
              onChange={e => setReason(e.target.value)}
            />
          </div>
          {error && <div className="text-danger mt-2">{error}</div>}
        </div>

        <div className="modal-footer">
          <button type="submit" className="btn btn-danger" disabled={loading}>
            {loading ? "Submitting..." : "Submit cancellation"}
          </button>
          <button type="button" className="btn btn-secondary" onClick={close}>
            Close
          </button>
        </div>
      </Form>
    </Modal>
  )
}

export default CancelModal
